(() => {
  const reveal = (scope = document) => {
    const items = scope.querySelectorAll('.reveal:not([data-reveal-ready])');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => {
        item.dataset.revealReady = 'true';
        item.classList.add('visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          activeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    items.forEach((item) => {
      item.dataset.revealReady = 'true';
      observer.observe(item);
    });
  };

  const connectCheckout = (scope = document) => {
    scope.querySelectorAll('.onipure-buy-form:not([data-checkout-ready])').forEach((form) => {
      form.dataset.checkoutReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[type="submit"]');
        const errorBox = form.querySelector('.form-error');
        const originalLabel = button.textContent;
        const root = window.Shopify?.routes?.root || '/';

        button.disabled = true;
        button.textContent = button.dataset.loadingText || 'Aggiunta…';
        errorBox.hidden = true;
        errorBox.textContent = '';

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });

          const payload = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Non è stato possibile aggiungere il prodotto.');
          }

          window.location.assign(`${root}checkout`);
        } catch (error) {
          errorBox.textContent = error.message || 'Si è verificato un errore. Riprova.';
          errorBox.hidden = false;
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
    });
  };

  const initialise = (scope = document) => {
    reveal(scope);
    connectCheckout(scope);
  };

  initialise();

  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target);
  });
})();
